const HANGUL_BASE = 0xac00, HANGUL_END = 0xd7a3;
export const hasFinalConsonant = (noun) => {
  if (!noun) return false;
  const last = String(noun).trim().slice(-1);
  if (!last) return false;
  const code = last.charCodeAt(0);
  if (code < HANGUL_BASE || code > HANGUL_END) return false;
  return (code - HANGUL_BASE) % 28 !== 0;
};
const PARTICLE = { '을를': ['을','를'], '이가': ['이','가'], '은는': ['은','는'] };
export const withParticle = (noun, pair) => {
  const set = PARTICLE[pair];
  if (!set) return String(noun ?? '');
  return `${noun}${hasFinalConsonant(noun) ? set[0] : set[1]}`;
};
export const requiredMessage = (label) => `${withParticle(label, '을를')} 입력해 주세요`;
